/**
 * studio-shop D5 — the countries checkout lets a buyer pick, in its order: the Prints mockup's, less Brazil and
 * Australia, closed for the beta. shop-self-fulfilment D4: also where Shipped by you can ship, so the studio is
 * offered only countries a buyer can choose. Browser-safe.
 */
export const SHOP_COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'MX', name: 'Mexico' },
  { code: 'JP', name: 'Japan' },
] as const;
